"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PASSWORD = void 0;
const COPY_1 = require("../messages/COPY.js");
const COPY_2 = require("../placeholders/COPY.js");
exports.PASSWORD = {
    MAX_LENGTH: 32,
    MIN_LENGTH: 8,
    PATTERN: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}/u,
    PLACEHOLDER: COPY_2.PLACEHOLDERS_COPY.PASSWORD,
    PLACEHOLDER_CONFIRM: COPY_2.PLACEHOLDERS_COPY.CONFIRM_PASSWORD,
    PLACEHOLDER_CURRENT: COPY_2.PLACEHOLDERS_COPY.CURRENT_PASSWORD,
    PLACEHOLDER_NEW: COPY_2.PLACEHOLDERS_COPY.NEW_PASSWORD,
    REQUIRED_MESSAGE: COPY_1.MESSAGES_COPY.PLEASE_ENTER_PASSWORD,
    REQUIRED_MESSAGE_CONFIRM: COPY_1.MESSAGES_COPY.PLEASE_CONFIRM_PASSWORD,
    REQUIRED_MESSAGE_CURRENT: COPY_1.MESSAGES_COPY.PLEASE_ENTER_CURRENT_PASSWORD,
    REQUIRED_MESSAGE_NEW: COPY_1.MESSAGES_COPY.PLEASE_ENTER_NEW_PASSWORD,
    REQUIREMENT_LENGTH: '8 or More Characters',
    REQUIREMENT_LOWERCASE: '1 Lowercase',
    REQUIREMENT_NONALPHANUMERIC: '1 Non-Alphanumeric',
    REQUIREMENT_NUMERIC: '1 Number',
    REQUIREMENT_UPPERCASE: '1 Uppercase'
};
//# sourceMappingURL=PASSWORD.js.map